import { render, staticRenderFns } from "./EventInfoPlace.vue?vue&type=template&id=2db893ed&scoped=true&"
import script from "./EventInfoPlace.vue?vue&type=script&lang=ts&"
export * from "./EventInfoPlace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db893ed",
  null
  
)

export default component.exports